import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card } from "@/components/ui/card";

export default function FirecrawlCheck() {
  const [url, setUrl] = useState("https://example.com");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<any>(null);

  const run = async () => {
    setLoading(true);
    setResult(null);
    const started = Date.now();
    const { data, error } = await supabase.functions.invoke("firecrawl-verify", { body: { url } });
    const clientLatency = Date.now() - started;
    setResult({ clientLatency, data, error: error?.message ?? null });
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-background p-6">
      <div className="max-w-2xl mx-auto space-y-4">
        <h1 className="text-2xl font-semibold">Firecrawl connection check</h1>
        <p className="text-sm text-muted-foreground">
          Runs a live <code>/v2/scrape</code> against the linked Firecrawl connection and reports the HTTP status.
        </p>
        <Card className="p-4 space-y-3">
          <Input value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://example.com" />
          <Button onClick={run} disabled={loading}>
            {loading ? "Running…" : "Run sample scrape"}
          </Button>
        </Card>
        {result && (
          <Card className="p-4">
            <div className="text-sm mb-2">
              <span className={result.data?.ok ? "text-green-600" : "text-red-600"}>
                {result.data?.ok ? "✅ OK" : "❌ Failed"}
              </span>{" "}
              — status <b>{result.data?.status ?? "n/a"}</b> · server {result.data?.latency_ms ?? "?"}ms · client {result.clientLatency}ms
            </div>
            <pre className="bg-muted p-3 rounded text-xs overflow-auto max-h-96">
              {JSON.stringify(result, null, 2)}
            </pre>
          </Card>
        )}
      </div>
    </div>
  );
}
